import {
  IGeneralSearch,
  IGeneralSearchParams,
  marketDataV4,
} from '@core/market-data-sdk';
import { SearchOutput, SearchUseCase } from './search-use-case';
import groupBy from 'lodash.groupby';
import keys from 'lodash.keys';
import { SearchItemEntity } from './entities/search-item';

export class GeneralSearchUseCase implements SearchUseCase {
  async execute(term: string): Promise<SearchOutput> {
    const result = await GeneralSearchUseCase.getAssets(term);

    const formattedAssets = GeneralSearchUseCase.assetsFormatter(result);
    const groupedAssets =
      GeneralSearchUseCase.groupAssetsByCategory(formattedAssets);

    return groupedAssets;
  }

  static async getAssets(
    term: string,
    params?: IGeneralSearchParams
  ): Promise<IGeneralSearch[]> {
    return marketDataV4.general.search(term, params);
  }

  static assetsFormatter(data: IGeneralSearch[]): SearchItemEntity[] {
    return data.map((asset) => new SearchItemEntity(asset));
  }

  static groupAssetsByCategory(data: SearchItemEntity[]) {
    let groups = groupBy(data, 'type');

    // Remove Groups with all assets has no quotes
    groups = Object.entries(groups).reduce((acc, [key, assets]) => {
      const allAssetsHasNoQuotes = assets.every((asset) =>
        asset.isDisabled(true)
      );

      if (allAssetsHasNoQuotes) {
        return acc;
      }

      return { ...acc, [key]: assets };
    }, {});

    const categoriesNames = keys(groups);
    let categories = [{ label: 'Tudo', disabled: false, slug: 'all' }];

    categories = categories.concat(
      categoriesNames.map((name) => ({
        slug: name,
        label: name,
        disabled: false,
      }))
    );

    const groupedAssets = !data?.length ? {} : { ...groups, all: data };

    return { groupedAssets, categories };
  }
}
